import React, { FC } from 'react'
import { createPortal } from 'react-dom'
import { Grid, csx } from '@vtex/admin-ui'

import { BottomSliderModalProps } from './typings'
import { BottomSliderModalProvider } from './BottomSliderModalProvider'
import { CSSTransitionGroup } from '../CSSTransitionGroup'

const Portal: FC = ({ children }) => {
  return createPortal(children, document.body)
}

const ModalOverlay: FC = () => {
  return (
    <Portal>
      <div
        className={csx({
          background: '$overlay',
          height: '100%',
          width: '100%',
          overflow: 'auto',
          zIndex: 999,
          top: '$space-0',
          bottom: '$space-0',
          left: '$space-0',
          right: '$space-0',
          position: 'fixed',
        })}
      />
    </Portal>
  )
}

export { BottomSliderModalProps }

export const BottomSliderModal: FC<BottomSliderModalProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  const transition = {
    transitionName: 'slideUp',
    transitionEnterTimeout: 800,
    transitionLeaveTimeout: 300,
  }

  return (
    <BottomSliderModalProvider isOpen={isOpen} onClose={onClose}>
      {isOpen ? <ModalOverlay /> : null}
      <Portal>
        <CSSTransitionGroup
          transitionName={transition.transitionName}
          transitionEnterTimeout={transition.transitionEnterTimeout}
          transitionLeaveTimeout={transition.transitionLeaveTimeout}
        >
          {isOpen ? (
            <Grid
              role="dialog"
              aria-modal
              aria-labelledby="dialog_title"
              className={csx({
                zIndex: 1000,
                position: 'absolute',
                background: '$primary',
                borderTopLeftRadius: '1rem',
                borderTopRightRadius: '1rem',
                width: '100%',
                bottom: '$space-0',
              })}
            >
              {children}
            </Grid>
          ) : null}
        </CSSTransitionGroup>
      </Portal>
    </BottomSliderModalProvider>
  )
}
